import Head from '@wigets/head.vue'
import Foot from '@wigets/foot.vue'
import {getUserMsg,getPVUV} from '@apis/apis.js'
import {showcontent} from '@utils/method.js'
export default {
  components: {
    "web-head": Head,
    "web-foot": Foot,
  },
  data() {
    return {
      tab: 6,
      totalCount: 0,
      page: 1,
      totalPage: 0,
      list: [],
      responseDialogVisible: false,
      // 当前相信问答内容
      curReplay: {}
    };
  },
  filters: {
    ifrepeat: function(v) {
      if (v && v !== "") {
        return "已回复";
      } else {
        return "未回复";
      }
    },
  },
  created() {
    this.getUserMsgs();
    this.getpvuv()
  },
  computed: {
    // 转义回复内容
    transStr() {
      return showcontent(showcontent(this.curReplay.replyContent));
    }
  },
  methods: {
    showcontent,
    // 埋点
    getpvuv(){
      this.$ajaxPost(getPVUV,{
        ip: sessionStorage.getItem('ip'),
        directoryOne: "关于我们",
        directoryTwo:null,
        directoryThree: null,
        cookie: sessionStorage.getItem('random')
      })
    },
    //获得用户建议列表
    getUserMsgs() {
      this.$ajaxGet(`${getUserMsg}`, {
        limit: 7,
        page: this.page,
      })
        .then((res) => {
          if (res.data.code != 0) {
            this.$message({
              title: "错误",
              type: "error",
              message: res.data.msg + ",请重新刷新页面",
            });
            return;
          } else {
            this.totalCount = res.data.data.totalCount;
            this.list = [...this.list, ...res.data.data.list];
            this.totalPage = Math.ceil(this.totalCount / 10);
          }
        })
        .catch((err) => {
          this.$alert(err + "网络请求异常，请稍后再试！", "警告", {
            confirmButtonText: "确定",
            type: "error",
          });
        });
    },
    navToTab(v) {
      this.$router.push({ name: "proposal", query: { type: v } });
    },
    //点击位置导航进行跳转
    navPosition(name) {
      this.$router.push({ name });
    },
    changeTab(val) {
      this.tab = val;
    },
    // 打开回复详情对话框
    openDetail(item) {
      this.curReplay = item;
      this.responseDialogVisible = true;
    }
  },
};